// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__15edH","additionalInfo":"AgreementModal_additionalInfo__2HpqY"};